<template>
    <div>
        <a-upload
            name="avatar"
            listType="picture-card"
            class="avatar-uploader"
            :showUploadList="false"
            :beforeUpload="beforeUpload"
            @change="handleChange"
            :customRequest="customRequest"
        >
            <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
            <div v-else >
                <a-icon :type="loading ? 'loading' : 'plus'" />
            </div>
        </a-upload>
    </div>
</template>
<script>
import { uploadImg } from '@/libs/api'
export default {
    props:['imageUrl'],
    model:{
        prop: 'imageUrl',
        event: 'updateImg'
    },
    data(){
        return{
            loading: false,
        }
    },
    methods:{
        handleChange(){

        },
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' ;
            if (!isJPG) {
                this.$message.error('只能上传jpg图片!');
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
            this.$message.error('图片不能超过2MB!');
            }
            return isJPG && isLt2M;
        },
        customRequest(data){
            let formData = new FormData()
            formData.append('file',data.file)
            this.loading = true
            uploadImg(formData).then(res=>{
                // this.imageUrl=res.fileUrl
                this.loading = false
                this.$emit('updateImg', res.fileUrl)
            },error=>{
                console.log(error)
                this.loading = false
            })
        },
    }
}
</script>
<style scoped>
.avatar-uploader{
    margin-top: 15px;
}
</style>